import Splide from '@splidejs/splide';

export default class Carousel {
    constructor(element) {
        this.carousel = element;
        this.currentSlide = this.carousel.querySelector(".splide__current_slide");
        this.totalSlide = this.carousel.querySelector(".splide__total_slide");
        this.gap = this.carousel.getAttribute("data-splide-gap") ? this.carousel.getAttribute("data-splide-gap") : "100px"
        this.gapSm = this.carousel.getAttribute("data-splide-gap-sm") ? this.carousel.getAttribute("data-splide-gap-sm") : "0px"

        // Default true
        this.arrows = this.carousel.getAttribute("data-splide-arrows") !== "false";
        this.loop = this.carousel.getAttribute("data-splide-loop") !== "false";

        // Default false
        this.autoWidth = this.carousel.getAttribute("data-splide-auto-width") === "true";
        this.fixedWidth = this.carousel.getAttribute("data-splide-fixed-width") === "300px";
        this.dots = this.carousel.getAttribute("data-splide-dots") === "true";

        const options = {
            type: this.loop ? "loop" : "slide",
            arrows: this.arrows,
            fixedWidth: this.fixedWidth,
            autoWidth: this.autoWidth,
            pagination: this.dots,
            gap: this.gap,
            breakpoints: {
                800: {
                    gap: this.gapSm
                }
            }
        }

        this.splide = new Splide(this.carousel, options).mount();
        this.initialize()
    }

    initialize() {
        if (this.currentSlide && this.totalSlide) {
            this.setTotalSlide()
            this.setCurrentSlide(1)

            this.splide.on('mounted move', () => {
                this.setCurrentSlide(this.splide.index + 1)
            });
        }
    }

    setTotalSlide() {
        this.totalSlide.innerHTML = this.splide.Components.Controller.getEnd() + 1
    }

    setCurrentSlide(index) {
        this.currentSlide.innerHTML = index
    }
}
